import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { WidgetAssetListComponent } from '../widget-asset-list.component';

@Component({
    selector: 'app-formly-asset-list',
    templateUrl: './formly-asset-list.component.html',
    standalone: true,
    imports: [
        WidgetAssetListComponent
    ]
})
export class FormlyAssetListComponent extends FieldType<FieldTypeConfig> {

}
